
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Account: 'Account',
  AccountCredential: 'AccountCredential',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  Identifier: 'Identifier',
  IdentifierReservation: 'IdentifierReservation',
  IdentityProjectionCursor: 'IdentityProjectionCursor',
  TwoFactor: 'TwoFactor',
  SignInAttemptLock: 'SignInAttemptLock',
  Passkey: 'Passkey',
  MfaEnrollment: 'MfaEnrollment',
  SsoConnection: 'SsoConnection',
  SsoConnectionRegistrationSlot: 'SsoConnectionRegistrationSlot',
  SsoConnectionReproofCursor: 'SsoConnectionReproofCursor',
  SsoCredential: 'SsoCredential',
  SsoVerifiedDomain: 'SsoVerifiedDomain',
  SsoVerifiedDomainHolder: 'SsoVerifiedDomainHolder',
  SsoAuthenticationActivity: 'SsoAuthenticationActivity',
  SsoProvider: 'SsoProvider',
  SsoBreakGlassBinding: 'SsoBreakGlassBinding',
  SsoActivationRecoveryReservation: 'SsoActivationRecoveryReservation',
  JoinRequest: 'JoinRequest',
  TeamUser: 'TeamUser',
  OrganizationUser: 'OrganizationUser',
  Team: 'Team',
  Organization: 'Organization',
  IssuedLicense: 'IssuedLicense',
  ActivationCode: 'ActivationCode',
  ConnectedBillingAccount: 'ConnectedBillingAccount',
  ConnectedCreditGrant: 'ConnectedCreditGrant',
  ConnectedInvoice: 'ConnectedInvoice',
  ScimRequestLog: 'ScimRequestLog',
  ScimToken: 'ScimToken',
  ScimExternalId: 'ScimExternalId',
  ScimUserResource: 'ScimUserResource',
  ScimDirectoryUser: 'ScimDirectoryUser',
  ScimSyncState: 'ScimSyncState',
  Project: 'Project',
  Department: 'Department',
  DepartmentMembershipHistory: 'DepartmentMembershipHistory',
  PlatformToolPolicy: 'PlatformToolPolicy',
  OrganizationInvite: 'OrganizationInvite',
  Monitor: 'Monitor',
  Cost: 'Cost',
  Topic: 'Topic',
  Dataset: 'Dataset',
  DatasetRecord: 'DatasetRecord',
  Dashboard: 'Dashboard',
  SavedView: 'SavedView',
  CustomGraph: 'CustomGraph',
  BatchEvaluation: 'BatchEvaluation',
  Trigger: 'Trigger',
  SlackIntegration: 'SlackIntegration',
  WebhookEndpoint: 'WebhookEndpoint',
  WebhookEndpointDelivery: 'WebhookEndpointDelivery',
  Experiment: 'Experiment',
  ExperimentVersion: 'ExperimentVersion',
  Annotation: 'Annotation',
  ModelProvider: 'ModelProvider',
  ModelProviderScope: 'ModelProviderScope',
  ModelDefaultConfig: 'ModelDefaultConfig',
  ModelDefaultConfigScope: 'ModelDefaultConfigScope',
  GithubInstallation: 'GithubInstallation',
  GithubPullRequest: 'GithubPullRequest',
  GithubBranchPullRequestCheck: 'GithubBranchPullRequestCheck',
  LangyConversationProjection: 'LangyConversationProjection',
  LangyTurnRequest: 'LangyTurnRequest',
  LangyActiveTurn: 'LangyActiveTurn',
  LangyConversationTurnProjection: 'LangyConversationTurnProjection',
  LangyMessageProjection: 'LangyMessageProjection',
  ProjectSecret: 'ProjectSecret',
  TriggerSent: 'TriggerSent',
  TriggerLatestEvaluation: 'TriggerLatestEvaluation',
  EmailSuppression: 'EmailSuppression',
  AnnotationScore: 'AnnotationScore',
  AnnotationQueue: 'AnnotationQueue',
  AnnotationQueueMembers: 'AnnotationQueueMembers',
  AnnotationQueueScores: 'AnnotationQueueScores',
  AnnotationQueueItem: 'AnnotationQueueItem',
  ShareLink: 'ShareLink',
  PinnedTrace: 'PinnedTrace',
  TraceEditOverlay: 'TraceEditOverlay',
  RetentionPolicy: 'RetentionPolicy',
  DataPrivacyPolicy: 'DataPrivacyPolicy',
  CustomLLMModelCost: 'CustomLLMModelCost',
  Workflow: 'Workflow',
  WorkflowVersion: 'WorkflowVersion',
  AuditLog: 'AuditLog',
  LlmPromptConfig: 'LlmPromptConfig',
  LlmPromptConfigVersion: 'LlmPromptConfigVersion',
  PromptTagAssignment: 'PromptTagAssignment',
  PromptTag: 'PromptTag',
  Analytics: 'Analytics',
  CustomRole: 'CustomRole',
  Notification: 'Notification',
  Agent: 'Agent',
  Evaluator: 'Evaluator',
  Scenario: 'Scenario',
  ScenarioVersion: 'ScenarioVersion',
  SimulationSuite: 'SimulationSuite',
  Subscription: 'Subscription',
  Invoice: 'Invoice',
  InvoiceItem: 'InvoiceItem',
  Group: 'Group',
  GroupMembership: 'GroupMembership',
  RoleBinding: 'RoleBinding',
  Grant: 'Grant',
  GrantUsage: 'GrantUsage',
  Role: 'Role',
  ApiKey: 'ApiKey',
  BillingMeterCheckpoint: 'BillingMeterCheckpoint',
  VirtualKey: 'VirtualKey',
  VirtualKeyScope: 'VirtualKeyScope',
  RoutingPolicy: 'RoutingPolicy',
  RoutingPolicyScope: 'RoutingPolicyScope',
  GatewayGuardrail: 'GatewayGuardrail',
  IngestionSource: 'IngestionSource',
  AnomalyRule: 'AnomalyRule',
  AnomalyAlert: 'AnomalyAlert',
  AiToolEntry: 'AiToolEntry',
  AiToolEntryTeam: 'AiToolEntryTeam',
  AiToolEntryDepartment: 'AiToolEntryDepartment',
  IngestionTemplate: 'IngestionTemplate',
  GatewayBudget: 'GatewayBudget',
  GatewayBudgetBucketBoundary: 'GatewayBudgetBucketBoundary',
  GatewayBudgetLedger: 'GatewayBudgetLedger',
  GatewayChangeEvent: 'GatewayChangeEvent',
  GatewayCacheRule: 'GatewayCacheRule',
  FeatureFlag: 'FeatureFlag',
  ProcessManagerInstance: 'ProcessManagerInstance',
  ProcessManagerInbox: 'ProcessManagerInbox',
  ProcessManagerOutbox: 'ProcessManagerOutbox',
  ProcessManagerOutboxAttempt: 'ProcessManagerOutboxAttempt',
  TopicClusteringRunProjection: 'TopicClusteringRunProjection',
  TopicModelProjection: 'TopicModelProjection',
  TopicClusteringRunHistoryProjection: 'TopicClusteringRunHistoryProjection',
  IngestionPullRunProjection: 'IngestionPullRunProjection',
  ScheduledJob: 'ScheduledJob',
  BugReport: 'BugReport',
  IdempotencyReceipt: 'IdempotencyReceipt',
  GatewayRealtimeSession: 'GatewayRealtimeSession',
  SystemMigrationTenantState: 'SystemMigrationTenantState',
  SystemMigrationEnrollment: 'SystemMigrationEnrollment',
  DiscoveredPerson: 'DiscoveredPerson',
  DiscoveredAgent: 'DiscoveredAgent',
  IdentityMatch: 'IdentityMatch',
  GovernanceTenantHistory: 'GovernanceTenantHistory',
  ErasedIdentifierSuppression: 'ErasedIdentifierSuppression',
  IdentityMatchSuggestion: 'IdentityMatchSuggestion',
  ConnectedSeatChange: 'ConnectedSeatChange',
  ConnectedStatement: 'ConnectedStatement',
  InstanceIdentity: 'InstanceIdentity',
  SelfHostedInstance: 'SelfHostedInstance',
  SelfHostedInstanceReport: 'SelfHostedInstanceReport'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  issuer: 'issuer',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  ext_expires_in: 'ext_expires_in',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const AccountCredentialScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  provider: 'provider',
  password: 'password',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AccountCredentialScalarFieldEnum = (typeof AccountCredentialScalarFieldEnum)[keyof typeof AccountCredentialScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  identifierId: 'identifierId',
  amr: 'amr',
  impersonating: 'impersonating',
  actorUserId: 'actorUserId',
  subjectUserId: 'subjectUserId',
  impersonationReason: 'impersonationReason',
  impersonationExpiresAt: 'impersonationExpiresAt',
  lastSeenAt: 'lastSeenAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  signupConfirmationPending: 'signupConfirmationPending',
  passkeySignupClaimHash: 'passkeySignupClaimHash',
  image: 'image',
  pendingSsoSetup: 'pendingSsoSetup',
  userHashKey: 'userHashKey',
  twoFactorEnabled: 'twoFactorEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastLoginAt: 'lastLoginAt',
  deactivatedAt: 'deactivatedAt',
  lastHomePath: 'lastHomePath',
  tracesExplorerTourDismissedAt: 'tracesExplorerTourDismissedAt',
  langyCodeAccessPreference: 'langyCodeAccessPreference',
  passkeyNudgeDismissedAt: 'passkeyNudgeDismissedAt',
  joinOfferDismissedDomains: 'joinOfferDismissedDomains'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const VerificationTokenScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  token: 'token',
  expires: 'expires',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type VerificationTokenScalarFieldEnum = (typeof VerificationTokenScalarFieldEnum)[keyof typeof VerificationTokenScalarFieldEnum]


export const IdentifierScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  provider: 'provider',
  value: 'value',
  domain: 'domain',
  identifierHash: 'identifierHash',
  accountId: 'accountId',
  providerId: 'providerId',
  issuer: 'issuer',
  providerAccountId: 'providerAccountId',
  state: 'state',
  connectionId: 'connectionId',
  verifiedAt: 'verifiedAt',
  attachedAt: 'attachedAt',
  detachedAt: 'detachedAt',
  lastUsedAt: 'lastUsedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IdentifierScalarFieldEnum = (typeof IdentifierScalarFieldEnum)[keyof typeof IdentifierScalarFieldEnum]


export const IdentifierReservationScalarFieldEnum = {
  normalizedValue: 'normalizedValue',
  userId: 'userId',
  identifierId: 'identifierId',
  commandId: 'commandId',
  createdAt: 'createdAt'
} as const

export type IdentifierReservationScalarFieldEnum = (typeof IdentifierReservationScalarFieldEnum)[keyof typeof IdentifierReservationScalarFieldEnum]


export const IdentityProjectionCursorScalarFieldEnum = {
  userId: 'userId',
  lastEventId: 'lastEventId',
  acceptedAt: 'acceptedAt',
  occurredAt: 'occurredAt',
  projectionVersion: 'projectionVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IdentityProjectionCursorScalarFieldEnum = (typeof IdentityProjectionCursorScalarFieldEnum)[keyof typeof IdentityProjectionCursorScalarFieldEnum]


export const TwoFactorScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  secret: 'secret',
  backupCodes: 'backupCodes',
  verified: 'verified',
  failedVerificationCount: 'failedVerificationCount',
  lockedUntil: 'lockedUntil',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TwoFactorScalarFieldEnum = (typeof TwoFactorScalarFieldEnum)[keyof typeof TwoFactorScalarFieldEnum]


export const SignInAttemptLockScalarFieldEnum = {
  id: 'id',
  identifierHash: 'identifierHash',
  failedCount: 'failedCount',
  lockedUntil: 'lockedUntil',
  consecutiveLockouts: 'consecutiveLockouts',
  heldForReview: 'heldForReview',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SignInAttemptLockScalarFieldEnum = (typeof SignInAttemptLockScalarFieldEnum)[keyof typeof SignInAttemptLockScalarFieldEnum]


export const PasskeyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  publicKey: 'publicKey',
  userId: 'userId',
  credentialID: 'credentialID',
  counter: 'counter',
  deviceType: 'deviceType',
  backedUp: 'backedUp',
  transports: 'transports',
  aaguid: 'aaguid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PasskeyScalarFieldEnum = (typeof PasskeyScalarFieldEnum)[keyof typeof PasskeyScalarFieldEnum]


export const MfaEnrollmentScalarFieldEnum = {
  userId: 'userId',
  enrollmentId: 'enrollmentId',
  method: 'method',
  state: 'state',
  enrolledAt: 'enrolledAt',
  confirmedAt: 'confirmedAt',
  expiredAt: 'expiredAt',
  disabledAt: 'disabledAt',
  disabledVia: 'disabledVia',
  backupCodeCount: 'backupCodeCount',
  consumedBackupCodeIndexes: 'consumedBackupCodeIndexes',
  failedCount: 'failedCount',
  occurredAt: 'occurredAt',
  lastEventId: 'lastEventId',
  acceptedAt: 'acceptedAt',
  projectionVersion: 'projectionVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MfaEnrollmentScalarFieldEnum = (typeof MfaEnrollmentScalarFieldEnum)[keyof typeof MfaEnrollmentScalarFieldEnum]


export const SsoConnectionScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  type: 'type',
  state: 'state',
  claimedDomains: 'claimedDomains',
  domainClaims: 'domainClaims',
  approvedDomains: 'approvedDomains',
  verifiedDomains: 'verifiedDomains',
  lapsedDomains: 'lapsedDomains',
  domainVerifications: 'domainVerifications',
  pendingVerification: 'pendingVerification',
  idpMetadata: 'idpMetadata',
  arrivalPolicy: 'arrivalPolicy',
  allowsJit: 'allowsJit',
  arrivalPolicyDecidedAt: 'arrivalPolicyDecidedAt',
  source: 'source',
  testLoginAccountId: 'testLoginAccountId',
  replacesConnectionId: 'replacesConnectionId',
  migrationPhase: 'migrationPhase',
  graceStartedAt: 'graceStartedAt',
  routeChangedAt: 'routeChangedAt',
  finalizationRequestedAt: 'finalizationRequestedAt',
  finalizedAt: 'finalizedAt',
  rejection: 'rejection',
  createdBy: 'createdBy',
  tearDownAfter: 'tearDownAfter',
  occurredAt: 'occurredAt',
  lastEventId: 'lastEventId',
  acceptedAt: 'acceptedAt',
  projectionVersion: 'projectionVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SsoConnectionScalarFieldEnum = (typeof SsoConnectionScalarFieldEnum)[keyof typeof SsoConnectionScalarFieldEnum]


export const SsoConnectionRegistrationSlotScalarFieldEnum = {
  organizationId: 'organizationId',
  kind: 'kind',
  connectionId: 'connectionId',
  replacesConnectionId: 'replacesConnectionId',
  commandId: 'commandId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SsoConnectionRegistrationSlotScalarFieldEnum = (typeof SsoConnectionRegistrationSlotScalarFieldEnum)[keyof typeof SsoConnectionRegistrationSlotScalarFieldEnum]


export const SsoConnectionReproofCursorScalarFieldEnum = {
  connectionId: 'connectionId',
  lastReproofAt: 'lastReproofAt'
} as const

export type SsoConnectionReproofCursorScalarFieldEnum = (typeof SsoConnectionReproofCursorScalarFieldEnum)[keyof typeof SsoConnectionReproofCursorScalarFieldEnum]


export const SsoCredentialScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  connectionId: 'connectionId',
  kind: 'kind',
  ciphertext: 'ciphertext',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SsoCredentialScalarFieldEnum = (typeof SsoCredentialScalarFieldEnum)[keyof typeof SsoCredentialScalarFieldEnum]


export const SsoVerifiedDomainScalarFieldEnum = {
  domain: 'domain',
  organizationId: 'organizationId'
} as const

export type SsoVerifiedDomainScalarFieldEnum = (typeof SsoVerifiedDomainScalarFieldEnum)[keyof typeof SsoVerifiedDomainScalarFieldEnum]


export const SsoVerifiedDomainHolderScalarFieldEnum = {
  domain: 'domain',
  connectionId: 'connectionId',
  organizationId: 'organizationId'
} as const

export type SsoVerifiedDomainHolderScalarFieldEnum = (typeof SsoVerifiedDomainHolderScalarFieldEnum)[keyof typeof SsoVerifiedDomainHolderScalarFieldEnum]


export const SsoAuthenticationActivityScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  connectionId: 'connectionId',
  userId: 'userId',
  authenticatedAt: 'authenticatedAt'
} as const

export type SsoAuthenticationActivityScalarFieldEnum = (typeof SsoAuthenticationActivityScalarFieldEnum)[keyof typeof SsoAuthenticationActivityScalarFieldEnum]


export const SsoProviderScalarFieldEnum = {
  id: 'id',
  issuer: 'issuer',
  oidcConfig: 'oidcConfig',
  samlConfig: 'samlConfig',
  userId: 'userId',
  providerId: 'providerId',
  organizationId: 'organizationId',
  domain: 'domain'
} as const

export type SsoProviderScalarFieldEnum = (typeof SsoProviderScalarFieldEnum)[keyof typeof SsoProviderScalarFieldEnum]


export const SsoBreakGlassBindingScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  userId: 'userId',
  grantedByUserId: 'grantedByUserId',
  grantedAt: 'grantedAt',
  expiresAt: 'expiresAt',
  supersededAt: 'supersededAt',
  renewedFromId: 'renewedFromId',
  warnedDays: 'warnedDays',
  createdAt: 'createdAt'
} as const

export type SsoBreakGlassBindingScalarFieldEnum = (typeof SsoBreakGlassBindingScalarFieldEnum)[keyof typeof SsoBreakGlassBindingScalarFieldEnum]


export const SsoActivationRecoveryReservationScalarFieldEnum = {
  commandId: 'commandId',
  organizationId: 'organizationId',
  connectionId: 'connectionId',
  createdAt: 'createdAt'
} as const

export type SsoActivationRecoveryReservationScalarFieldEnum = (typeof SsoActivationRecoveryReservationScalarFieldEnum)[keyof typeof SsoActivationRecoveryReservationScalarFieldEnum]


export const JoinRequestScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  organizationId: 'organizationId',
  domain: 'domain',
  state: 'state',
  matchedVia: 'matchedVia',
  expiresAt: 'expiresAt',
  resolvedAt: 'resolvedAt',
  resolvedByType: 'resolvedByType',
  resolvedById: 'resolvedById',
  withdrawalCause: 'withdrawalCause',
  occurredAt: 'occurredAt',
  lastEventId: 'lastEventId',
  acceptedAt: 'acceptedAt',
  projectionVersion: 'projectionVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type JoinRequestScalarFieldEnum = (typeof JoinRequestScalarFieldEnum)[keyof typeof JoinRequestScalarFieldEnum]


export const TeamUserScalarFieldEnum = {
  userId: 'userId',
  teamId: 'teamId',
  role: 'role',
  assignedRoleId: 'assignedRoleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TeamUserScalarFieldEnum = (typeof TeamUserScalarFieldEnum)[keyof typeof TeamUserScalarFieldEnum]


export const OrganizationUserScalarFieldEnum = {
  userId: 'userId',
  organizationId: 'organizationId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  departmentId: 'departmentId',
  disabledAt: 'disabledAt',
  pendingSsoGrantId: 'pendingSsoGrantId',
  membershipStamp: 'membershipStamp'
} as const

export type OrganizationUserScalarFieldEnum = (typeof OrganizationUserScalarFieldEnum)[keyof typeof OrganizationUserScalarFieldEnum]


export const TeamScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  isPersonal: 'isPersonal',
  ownerUserId: 'ownerUserId',
  departmentId: 'departmentId'
} as const

export type TeamScalarFieldEnum = (typeof TeamScalarFieldEnum)[keyof typeof TeamScalarFieldEnum]


export const OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  phoneNumber: 'phoneNumber',
  slug: 'slug',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  usageSpendingMaxLimit: 'usageSpendingMaxLimit',
  maxSessionDurationDays: 'maxSessionDurationDays',
  mfaRequired: 'mfaRequired',
  lockoutAfterFailedAttempts: 'lockoutAfterFailedAttempts',
  lockoutMinutes: 'lockoutMinutes',
  sessionIdleTimeoutMinutes: 'sessionIdleTimeoutMinutes',
  sessionMaxLifetimeMinutes: 'sessionMaxLifetimeMinutes',
  signupData: 'signupData',
  signedDPA: 'signedDPA',
  elasticsearchNodeUrl: 'elasticsearchNodeUrl',
  elasticsearchApiKey: 'elasticsearchApiKey',
  useCustomElasticsearch: 'useCustomElasticsearch',
  s3Endpoint: 's3Endpoint',
  s3AccessKeyId: 's3AccessKeyId',
  s3SecretAccessKey: 's3SecretAccessKey',
  s3Bucket: 's3Bucket',
  useCustomS3: 'useCustomS3',
  sentPlanLimitAlert: 'sentPlanLimitAlert',
  ssoDomain: 'ssoDomain',
  ssoProvider: 'ssoProvider',
  domainJoin: 'domainJoin',
  joinDomains: 'joinDomains',
  presenceEnabled: 'presenceEnabled',
  traceSharingEnabled: 'traceSharingEnabled',
  supportContact: 'supportContact',
  primaryIntent: 'primaryIntent',
  promoCode: 'promoCode',
  stripeCustomerId: 'stripeCustomerId',
  currency: 'currency',
  pricingModel: 'pricingModel',
  license: 'license',
  licenseExpiresAt: 'licenseExpiresAt',
  licenseLastValidatedAt: 'licenseLastValidatedAt',
  selfHostedCustomer: 'selfHostedCustomer',
  connectServicesDisabled: 'connectServicesDisabled',
  connectLastSyncAt: 'connectLastSyncAt',
  connectLastSyncError: 'connectLastSyncError'
} as const

export type OrganizationScalarFieldEnum = (typeof OrganizationScalarFieldEnum)[keyof typeof OrganizationScalarFieldEnum]


export const IssuedLicenseScalarFieldEnum = {
  id: 'id',
  licenseId: 'licenseId',
  tokenHash: 'tokenHash',
  organizationId: 'organizationId',
  organizationName: 'organizationName',
  email: 'email',
  planType: 'planType',
  maxMembers: 'maxMembers',
  maxMembersLite: 'maxMembersLite',
  issuedAt: 'issuedAt',
  expiresAt: 'expiresAt',
  source: 'source',
  issuedById: 'issuedById',
  revokedAt: 'revokedAt',
  revokedById: 'revokedById',
  revokedReason: 'revokedReason',
  supersededAt: 'supersededAt',
  replacesId: 'replacesId',
  pendingDeliveryLicense: 'pendingDeliveryLicense',
  services: 'services',
  seatRateCents: 'seatRateCents',
  seatCurrency: 'seatCurrency',
  commitUsdCents: 'commitUsdCents',
  overageEnabled: 'overageEnabled',
  overageMaxUsdCents: 'overageMaxUsdCents',
  instanceId: 'instanceId',
  instanceBoundAt: 'instanceBoundAt',
  lastSyncAt: 'lastSyncAt',
  lastSyncVersion: 'lastSyncVersion',
  reportedMembers: 'reportedMembers',
  reportedMembersLite: 'reportedMembersLite',
  virtualKeyId: 'virtualKeyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IssuedLicenseScalarFieldEnum = (typeof IssuedLicenseScalarFieldEnum)[keyof typeof IssuedLicenseScalarFieldEnum]


export const ActivationCodeScalarFieldEnum = {
  id: 'id',
  codeHash: 'codeHash',
  codeHint: 'codeHint',
  organizationId: 'organizationId',
  organizationName: 'organizationName',
  email: 'email',
  planType: 'planType',
  maxMembers: 'maxMembers',
  maxMembersLite: 'maxMembersLite',
  licenseTermDays: 'licenseTermDays',
  services: 'services',
  expiresAt: 'expiresAt',
  reusable: 'reusable',
  redeemedAt: 'redeemedAt',
  redeemedByInstanceId: 'redeemedByInstanceId',
  issuedLicenseId: 'issuedLicenseId',
  redemptionCount: 'redemptionCount',
  revokedAt: 'revokedAt',
  revokedById: 'revokedById',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ActivationCodeScalarFieldEnum = (typeof ActivationCodeScalarFieldEnum)[keyof typeof ActivationCodeScalarFieldEnum]


export const ConnectedBillingAccountScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  stripeCustomerId: 'stripeCustomerId',
  usageSubscriptionId: 'usageSubscriptionId',
  usageSubscriptionItemId: 'usageSubscriptionItemId',
  termStartsAt: 'termStartsAt',
  termEndsAt: 'termEndsAt',
  commitUsdCents: 'commitUsdCents',
  seatCurrency: 'seatCurrency',
  seatRateCents: 'seatRateCents',
  seats: 'seats',
  bankTransferType: 'bankTransferType',
  bankTransferCountry: 'bankTransferCountry',
  billingEmail: 'billingEmail',
  pendingRenewal: 'pendingRenewal',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ConnectedBillingAccountScalarFieldEnum = (typeof ConnectedBillingAccountScalarFieldEnum)[keyof typeof ConnectedBillingAccountScalarFieldEnum]


export const ConnectedCreditGrantScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  stripeCreditGrantId: 'stripeCreditGrantId',
  amountUsdCents: 'amountUsdCents',
  kind: 'kind',
  termEndsAt: 'termEndsAt',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt'
} as const

export type ConnectedCreditGrantScalarFieldEnum = (typeof ConnectedCreditGrantScalarFieldEnum)[keyof typeof ConnectedCreditGrantScalarFieldEnum]


export const ConnectedInvoiceScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  stripeInvoiceId: 'stripeInvoiceId',
  kind: 'kind',
  currency: 'currency',
  amountCents: 'amountCents',
  status: 'status',
  paidOutOfBandAt: 'paidOutOfBandAt',
  termStartsAt: 'termStartsAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ConnectedInvoiceScalarFieldEnum = (typeof ConnectedInvoiceScalarFieldEnum)[keyof typeof ConnectedInvoiceScalarFieldEnum]


export const ScimRequestLogScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  connectionId: 'connectionId',
  method: 'method',
  resource: 'resource',
  status: 'status',
  reason: 'reason',
  detail: 'detail',
  occurredAt: 'occurredAt'
} as const

export type ScimRequestLogScalarFieldEnum = (typeof ScimRequestLogScalarFieldEnum)[keyof typeof ScimRequestLogScalarFieldEnum]


export const ScimTokenScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  connectionId: 'connectionId',
  hashedToken: 'hashedToken',
  hashScheme: 'hashScheme',
  description: 'description',
  createdAt: 'createdAt',
  lastUsedAt: 'lastUsedAt'
} as const

export type ScimTokenScalarFieldEnum = (typeof ScimTokenScalarFieldEnum)[keyof typeof ScimTokenScalarFieldEnum]


export const ScimExternalIdScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  connectionId: 'connectionId',
  externalId: 'externalId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScimExternalIdScalarFieldEnum = (typeof ScimExternalIdScalarFieldEnum)[keyof typeof ScimExternalIdScalarFieldEnum]


export const ScimUserResourceScalarFieldEnum = {
  organizationId: 'organizationId',
  userId: 'userId',
  userName: 'userName',
  name: 'name',
  active: 'active',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScimUserResourceScalarFieldEnum = (typeof ScimUserResourceScalarFieldEnum)[keyof typeof ScimUserResourceScalarFieldEnum]


export const ScimDirectoryUserScalarFieldEnum = {
  organizationId: 'organizationId',
  connectionId: 'connectionId',
  userId: 'userId'
} as const

export type ScimDirectoryUserScalarFieldEnum = (typeof ScimDirectoryUserScalarFieldEnum)[keyof typeof ScimDirectoryUserScalarFieldEnum]


export const ScimSyncStateScalarFieldEnum = {
  id: 'id',
  connectionId: 'connectionId',
  organizationId: 'organizationId',
  state: 'state',
  lastPushedAt: 'lastPushedAt',
  lastFailure: 'lastFailure',
  deadLetters: 'deadLetters',
  revokedCause: 'revokedCause',
  occurredAt: 'occurredAt',
  lastEventId: 'lastEventId',
  acceptedAt: 'acceptedAt',
  projectionVersion: 'projectionVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScimSyncStateScalarFieldEnum = (typeof ScimSyncStateScalarFieldEnum)[keyof typeof ScimSyncStateScalarFieldEnum]


export const ProjectScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  apiKey: 'apiKey',
  lwqlKey: 'lwqlKey',
  teamId: 'teamId',
  language: 'language',
  framework: 'framework',
  kind: 'kind',
  firstMessage: 'firstMessage',
  integrated: 'integrated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userLinkTemplate: 'userLinkTemplate',
  traceSharingEnabled: 'traceSharingEnabled',
  presenceEnabled: 'presenceEnabled',
  s3Endpoint: 's3Endpoint',
  s3AccessKeyId: 's3AccessKeyId',
  s3SecretAccessKey: 's3SecretAccessKey',
  s3Bucket: 's3Bucket',
  archivedAt: 'archivedAt',
  isPersonal: 'isPersonal',
  ownerUserId: 'ownerUserId',
  personalFeatures: 'personalFeatures',
  departmentId: 'departmentId',
  langyEgressAllowlist: 'langyEgressAllowlist',
  lastCodingAgentSessionAt: 'lastCodingAgentSessionAt',
  lastCodingAgentPullRequestAt: 'lastCodingAgentPullRequestAt'
} as const

export type ProjectScalarFieldEnum = (typeof ProjectScalarFieldEnum)[keyof typeof ProjectScalarFieldEnum]


export const DepartmentScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt'
} as const

export type DepartmentScalarFieldEnum = (typeof DepartmentScalarFieldEnum)[keyof typeof DepartmentScalarFieldEnum]


export const DepartmentMembershipHistoryScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  userId: 'userId',
  departmentId: 'departmentId',
  validFrom: 'validFrom',
  validTo: 'validTo',
  createdAt: 'createdAt'
} as const

export type DepartmentMembershipHistoryScalarFieldEnum = (typeof DepartmentMembershipHistoryScalarFieldEnum)[keyof typeof DepartmentMembershipHistoryScalarFieldEnum]


export const PlatformToolPolicyScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  toolSlug: 'toolSlug',
  allowVk: 'allowVk',
  allowOtelDirect: 'allowOtelDirect',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlatformToolPolicyScalarFieldEnum = (typeof PlatformToolPolicyScalarFieldEnum)[keyof typeof PlatformToolPolicyScalarFieldEnum]


export const OrganizationInviteScalarFieldEnum = {
  id: 'id',
  email: 'email',
  inviteCode: 'inviteCode',
  expiration: 'expiration',
  status: 'status',
  organizationId: 'organizationId',
  teamIds: 'teamIds',
  teamAssignments: 'teamAssignments',
  role: 'role',
  requestedBy: 'requestedBy',
  subscriptionId: 'subscriptionId',
  acceptedByUserId: 'acceptedByUserId',
  acceptedViaIdentifierId: 'acceptedViaIdentifierId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrganizationInviteScalarFieldEnum = (typeof OrganizationInviteScalarFieldEnum)[keyof typeof OrganizationInviteScalarFieldEnum]


export const MonitorScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  experimentId: 'experimentId',
  evaluatorId: 'evaluatorId',
  checkType: 'checkType',
  name: 'name',
  slug: 'slug',
  executionMode: 'executionMode',
  enabled: 'enabled',
  preconditions: 'preconditions',
  parameters: 'parameters',
  mappings: 'mappings',
  sample: 'sample',
  level: 'level',
  threadIdleTimeout: 'threadIdleTimeout',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MonitorScalarFieldEnum = (typeof MonitorScalarFieldEnum)[keyof typeof MonitorScalarFieldEnum]


export const CostScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  costType: 'costType',
  costName: 'costName',
  referenceType: 'referenceType',
  referenceId: 'referenceId',
  amount: 'amount',
  currency: 'currency',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  extraInfo: 'extraInfo'
} as const

export type CostScalarFieldEnum = (typeof CostScalarFieldEnum)[keyof typeof CostScalarFieldEnum]


export const TopicScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  parentId: 'parentId',
  embeddings_model: 'embeddings_model',
  centroid: 'centroid',
  p95Distance: 'p95Distance',
  automaticallyGenerated: 'automaticallyGenerated',
  lastEventId: 'lastEventId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TopicScalarFieldEnum = (typeof TopicScalarFieldEnum)[keyof typeof TopicScalarFieldEnum]


export const DatasetScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  slug: 'slug',
  columnTypes: 'columnTypes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  mapping: 'mapping',
  useS3: 'useS3',
  s3RecordCount: 's3RecordCount',
  contentLayout: 'contentLayout',
  status: 'status',
  statusError: 'statusError',
  stagingKey: 'stagingKey',
  uploadFilename: 'uploadFilename',
  rowCount: 'rowCount',
  sizeBytes: 'sizeBytes',
  chunkCount: 'chunkCount',
  chunkOffsets: 'chunkOffsets'
} as const

export type DatasetScalarFieldEnum = (typeof DatasetScalarFieldEnum)[keyof typeof DatasetScalarFieldEnum]


export const DatasetRecordScalarFieldEnum = {
  id: 'id',
  datasetId: 'datasetId',
  projectId: 'projectId',
  entry: 'entry',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DatasetRecordScalarFieldEnum = (typeof DatasetRecordScalarFieldEnum)[keyof typeof DatasetRecordScalarFieldEnum]


export const DashboardScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DashboardScalarFieldEnum = (typeof DashboardScalarFieldEnum)[keyof typeof DashboardScalarFieldEnum]


export const SavedViewScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  userId: 'userId',
  name: 'name',
  filters: 'filters',
  query: 'query',
  period: 'period',
  order: 'order',
  kind: 'kind',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SavedViewScalarFieldEnum = (typeof SavedViewScalarFieldEnum)[keyof typeof SavedViewScalarFieldEnum]


export const CustomGraphScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  graph: 'graph',
  filters: 'filters',
  kind: 'kind',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dashboardId: 'dashboardId',
  gridColumn: 'gridColumn',
  gridRow: 'gridRow',
  colSpan: 'colSpan',
  rowSpan: 'rowSpan'
} as const

export type CustomGraphScalarFieldEnum = (typeof CustomGraphScalarFieldEnum)[keyof typeof CustomGraphScalarFieldEnum]


export const BatchEvaluationScalarFieldEnum = {
  id: 'id',
  experimentId: 'experimentId',
  projectId: 'projectId',
  data: 'data',
  status: 'status',
  score: 'score',
  label: 'label',
  passed: 'passed',
  details: 'details',
  cost: 'cost',
  datasetSlug: 'datasetSlug',
  datasetId: 'datasetId',
  evaluation: 'evaluation',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BatchEvaluationScalarFieldEnum = (typeof BatchEvaluationScalarFieldEnum)[keyof typeof BatchEvaluationScalarFieldEnum]


export const TriggerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  projectId: 'projectId',
  action: 'action',
  triggerKind: 'triggerKind',
  actionParams: 'actionParams',
  filters: 'filters',
  filterQuery: 'filterQuery',
  lastRunAt: 'lastRunAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active',
  pausedReason: 'pausedReason',
  pausedAt: 'pausedAt',
  message: 'message',
  deleted: 'deleted',
  alertType: 'alertType',
  slackTemplateType: 'slackTemplateType',
  slackTemplate: 'slackTemplate',
  emailSubjectTemplate: 'emailSubjectTemplate',
  emailBodyTemplate: 'emailBodyTemplate',
  notificationCadence: 'notificationCadence',
  traceDebounceMs: 'traceDebounceMs',
  customGraphId: 'customGraphId'
} as const

export type TriggerScalarFieldEnum = (typeof TriggerScalarFieldEnum)[keyof typeof TriggerScalarFieldEnum]


export const SlackIntegrationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  kind: 'kind',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  organizationId: 'organizationId',
  botTokenEncrypted: 'botTokenEncrypted',
  webhookUrlEncrypted: 'webhookUrlEncrypted',
  secretFingerprint: 'secretFingerprint',
  secretHint: 'secretHint',
  slackTeamId: 'slackTeamId',
  slackTeamName: 'slackTeamName',
  createdById: 'createdById',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SlackIntegrationScalarFieldEnum = (typeof SlackIntegrationScalarFieldEnum)[keyof typeof SlackIntegrationScalarFieldEnum]


export const WebhookEndpointScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  destinationKind: 'destinationKind',
  url: 'url',
  sqsQueueUrl: 'sqsQueueUrl',
  sqsRoleArn: 'sqsRoleArn',
  sqsExternalId: 'sqsExternalId',
  sqsAccessKeyId: 'sqsAccessKeyId',
  sqsSecretAccessKeyEncrypted: 'sqsSecretAccessKeyEncrypted',
  secretEncrypted: 'secretEncrypted',
  previousSecretEncrypted: 'previousSecretEncrypted',
  previousSecretExpiresAt: 'previousSecretExpiresAt',
  enabledEvents: 'enabledEvents',
  status: 'status',
  disabledReason: 'disabledReason',
  disabledAt: 'disabledAt',
  failingSince: 'failingSince',
  maxBatchSize: 'maxBatchSize',
  maxBatchDelayMs: 'maxBatchDelayMs',
  maxInFlight: 'maxInFlight',
  lastSuccessAt: 'lastSuccessAt',
  lastFailureAt: 'lastFailureAt',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WebhookEndpointScalarFieldEnum = (typeof WebhookEndpointScalarFieldEnum)[keyof typeof WebhookEndpointScalarFieldEnum]


export const WebhookEndpointDeliveryScalarFieldEnum = {
  id: 'id',
  channel: 'channel',
  organizationId: 'organizationId',
  endpointId: 'endpointId',
  projectId: 'projectId',
  triggerId: 'triggerId',
  dispatchId: 'dispatchId',
  attempt: 'attempt',
  eventCount: 'eventCount',
  responseStatus: 'responseStatus',
  latencyMs: 'latencyMs',
  error: 'error',
  response: 'response',
  outcome: 'outcome',
  firedAt: 'firedAt',
  createdAt: 'createdAt'
} as const

export type WebhookEndpointDeliveryScalarFieldEnum = (typeof WebhookEndpointDeliveryScalarFieldEnum)[keyof typeof WebhookEndpointDeliveryScalarFieldEnum]


export const ExperimentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  slug: 'slug',
  projectId: 'projectId',
  workflowId: 'workflowId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  workbenchState: 'workbenchState',
  workbenchVersion: 'workbenchVersion'
} as const

export type ExperimentScalarFieldEnum = (typeof ExperimentScalarFieldEnum)[keyof typeof ExperimentScalarFieldEnum]


export const ExperimentVersionScalarFieldEnum = {
  id: 'id',
  experimentId: 'experimentId',
  projectId: 'projectId',
  version: 'version',
  counterVersion: 'counterVersion',
  autoSaved: 'autoSaved',
  commitMessage: 'commitMessage',
  authorId: 'authorId',
  authorLabel: 'authorLabel',
  runId: 'runId',
  state: 'state',
  schemaVersion: 'schemaVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ExperimentVersionScalarFieldEnum = (typeof ExperimentVersionScalarFieldEnum)[keyof typeof ExperimentVersionScalarFieldEnum]


export const AnnotationScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  traceId: 'traceId',
  comment: 'comment',
  isThumbsUp: 'isThumbsUp',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  scoreOptions: 'scoreOptions',
  expectedOutput: 'expectedOutput',
  anchorKind: 'anchorKind',
  anchorId: 'anchorId',
  anchorPath: 'anchorPath'
} as const

export type AnnotationScalarFieldEnum = (typeof AnnotationScalarFieldEnum)[keyof typeof AnnotationScalarFieldEnum]


export const ModelProviderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  provider: 'provider',
  routingHandle: 'routingHandle',
  enabled: 'enabled',
  customKeys: 'customKeys',
  extraHeaders: 'extraHeaders',
  customModels: 'customModels',
  customEmbeddingsModels: 'customEmbeddingsModels',
  deploymentMapping: 'deploymentMapping',
  rateLimitRpm: 'rateLimitRpm',
  rateLimitTpm: 'rateLimitTpm',
  rateLimitRpd: 'rateLimitRpd',
  rotationPolicy: 'rotationPolicy',
  providerConfig: 'providerConfig',
  fallbackPriorityGlobal: 'fallbackPriorityGlobal',
  langySkipPermissionsModels: 'langySkipPermissionsModels',
  healthStatus: 'healthStatus',
  circuitOpenedAt: 'circuitOpenedAt',
  lastHealthCheckAt: 'lastHealthCheckAt',
  disabledAt: 'disabledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId'
} as const

export type ModelProviderScalarFieldEnum = (typeof ModelProviderScalarFieldEnum)[keyof typeof ModelProviderScalarFieldEnum]


export const ModelProviderScopeScalarFieldEnum = {
  id: 'id',
  modelProviderId: 'modelProviderId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  createdAt: 'createdAt'
} as const

export type ModelProviderScopeScalarFieldEnum = (typeof ModelProviderScopeScalarFieldEnum)[keyof typeof ModelProviderScopeScalarFieldEnum]


export const ModelDefaultConfigScalarFieldEnum = {
  id: 'id',
  config: 'config',
  authorId: 'authorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId'
} as const

export type ModelDefaultConfigScalarFieldEnum = (typeof ModelDefaultConfigScalarFieldEnum)[keyof typeof ModelDefaultConfigScalarFieldEnum]


export const ModelDefaultConfigScopeScalarFieldEnum = {
  id: 'id',
  configId: 'configId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  createdAt: 'createdAt'
} as const

export type ModelDefaultConfigScopeScalarFieldEnum = (typeof ModelDefaultConfigScopeScalarFieldEnum)[keyof typeof ModelDefaultConfigScopeScalarFieldEnum]


export const GithubInstallationScalarFieldEnum = {
  id: 'id',
  installationId: 'installationId',
  organizationId: 'organizationId',
  accountLogin: 'accountLogin',
  accountType: 'accountType',
  accountId: 'accountId',
  repositorySelection: 'repositorySelection',
  repositories: 'repositories',
  suspendedAt: 'suspendedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GithubInstallationScalarFieldEnum = (typeof GithubInstallationScalarFieldEnum)[keyof typeof GithubInstallationScalarFieldEnum]


export const GithubPullRequestScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  repositoryHost: 'repositoryHost',
  repositoryFullName: 'repositoryFullName',
  headBranch: 'headBranch',
  prNumber: 'prNumber',
  htmlUrl: 'htmlUrl',
  title: 'title',
  state: 'state',
  isDraft: 'isDraft',
  authorLogin: 'authorLogin',
  prCreatedAt: 'prCreatedAt',
  prClosedAt: 'prClosedAt',
  prMergedAt: 'prMergedAt',
  prUpdatedAt: 'prUpdatedAt',
  mappedAt: 'mappedAt',
  lastCheckedAt: 'lastCheckedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GithubPullRequestScalarFieldEnum = (typeof GithubPullRequestScalarFieldEnum)[keyof typeof GithubPullRequestScalarFieldEnum]


export const GithubBranchPullRequestCheckScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  repositoryHost: 'repositoryHost',
  repositoryFullName: 'repositoryFullName',
  headBranch: 'headBranch',
  lastCheckedAt: 'lastCheckedAt',
  prCount: 'prCount',
  notFoundAt: 'notFoundAt',
  recheckAfter: 'recheckAfter',
  attempts: 'attempts',
  lastRequestedAt: 'lastRequestedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GithubBranchPullRequestCheckScalarFieldEnum = (typeof GithubBranchPullRequestCheckScalarFieldEnum)[keyof typeof GithubBranchPullRequestCheckScalarFieldEnum]


export const LangyConversationProjectionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  ConversationId: 'ConversationId',
  UserId: 'UserId',
  Title: 'Title',
  TitleSource: 'TitleSource',
  Status: 'Status',
  IsShared: 'IsShared',
  SharedAt: 'SharedAt',
  SharedById: 'SharedById',
  MessageCount: 'MessageCount',
  LastActivityAt: 'LastActivityAt',
  CurrentTurnId: 'CurrentTurnId',
  LastError: 'LastError',
  LastModel: 'LastModel',
  PendingHandoffToken: 'PendingHandoffToken',
  PendingHandoffTurnId: 'PendingHandoffTurnId',
  RunToken: 'RunToken',
  ArchivedAt: 'ArchivedAt',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  LastEventId: 'LastEventId',
  ProjectionVersion: 'ProjectionVersion'
} as const

export type LangyConversationProjectionScalarFieldEnum = (typeof LangyConversationProjectionScalarFieldEnum)[keyof typeof LangyConversationProjectionScalarFieldEnum]


export const LangyTurnRequestScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  userId: 'userId',
  requestId: 'requestId',
  conversationId: 'conversationId',
  turnId: 'turnId',
  status: 'status',
  leaseOwner: 'leaseOwner',
  leaseExpiresAt: 'leaseExpiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LangyTurnRequestScalarFieldEnum = (typeof LangyTurnRequestScalarFieldEnum)[keyof typeof LangyTurnRequestScalarFieldEnum]


export const LangyActiveTurnScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  conversationId: 'conversationId',
  turnId: 'turnId',
  requestId: 'requestId',
  userId: 'userId',
  status: 'status',
  leaseOwner: 'leaseOwner',
  leaseExpiresAt: 'leaseExpiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LangyActiveTurnScalarFieldEnum = (typeof LangyActiveTurnScalarFieldEnum)[keyof typeof LangyActiveTurnScalarFieldEnum]


export const LangyConversationTurnProjectionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  ConversationId: 'ConversationId',
  TurnId: 'TurnId',
  Status: 'Status',
  QuestionParts: 'QuestionParts',
  AnswerParts: 'AnswerParts',
  ToolCalls: 'ToolCalls',
  Plan: 'Plan',
  Error: 'Error',
  StartedAt: 'StartedAt',
  EndedAt: 'EndedAt',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  LastEventId: 'LastEventId',
  ProjectionVersion: 'ProjectionVersion'
} as const

export type LangyConversationTurnProjectionScalarFieldEnum = (typeof LangyConversationTurnProjectionScalarFieldEnum)[keyof typeof LangyConversationTurnProjectionScalarFieldEnum]


export const LangyMessageProjectionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  ConversationId: 'ConversationId',
  MessageId: 'MessageId',
  Role: 'Role',
  Parts: 'Parts',
  SourceEventId: 'SourceEventId',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
} as const

export type LangyMessageProjectionScalarFieldEnum = (typeof LangyMessageProjectionScalarFieldEnum)[keyof typeof LangyMessageProjectionScalarFieldEnum]


export const ProjectSecretScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  encryptedValue: 'encryptedValue',
  createdById: 'createdById',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ProjectSecretScalarFieldEnum = (typeof ProjectSecretScalarFieldEnum)[keyof typeof ProjectSecretScalarFieldEnum]


export const TriggerSentScalarFieldEnum = {
  id: 'id',
  triggerId: 'triggerId',
  traceId: 'traceId',
  customGraphId: 'customGraphId',
  projectId: 'projectId',
  resolvedAt: 'resolvedAt',
  openIncidentKey: 'openIncidentKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TriggerSentScalarFieldEnum = (typeof TriggerSentScalarFieldEnum)[keyof typeof TriggerSentScalarFieldEnum]


export const TriggerLatestEvaluationScalarFieldEnum = {
  triggerId: 'triggerId',
  projectId: 'projectId',
  evaluatedAt: 'evaluatedAt',
  verdict: 'verdict',
  observedValue: 'observedValue',
  threshold: 'threshold',
  operator: 'operator',
  timePeriodMinutes: 'timePeriodMinutes',
  skipCode: 'skipCode',
  updatedAt: 'updatedAt'
} as const

export type TriggerLatestEvaluationScalarFieldEnum = (typeof TriggerLatestEvaluationScalarFieldEnum)[keyof typeof TriggerLatestEvaluationScalarFieldEnum]


export const EmailSuppressionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  email: 'email',
  triggerId: 'triggerId',
  reason: 'reason',
  createdAt: 'createdAt'
} as const

export type EmailSuppressionScalarFieldEnum = (typeof EmailSuppressionScalarFieldEnum)[keyof typeof EmailSuppressionScalarFieldEnum]


export const AnnotationScoreScalarFieldEnum = {
  id: 'id',
  name: 'name',
  projectId: 'projectId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  active: 'active',
  dataType: 'dataType',
  options: 'options',
  defaultValue: 'defaultValue',
  global: 'global'
} as const

export type AnnotationScoreScalarFieldEnum = (typeof AnnotationScoreScalarFieldEnum)[keyof typeof AnnotationScoreScalarFieldEnum]


export const AnnotationQueueScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  projectId: 'projectId',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AnnotationQueueScalarFieldEnum = (typeof AnnotationQueueScalarFieldEnum)[keyof typeof AnnotationQueueScalarFieldEnum]


export const AnnotationQueueMembersScalarFieldEnum = {
  annotationQueueId: 'annotationQueueId',
  userId: 'userId'
} as const

export type AnnotationQueueMembersScalarFieldEnum = (typeof AnnotationQueueMembersScalarFieldEnum)[keyof typeof AnnotationQueueMembersScalarFieldEnum]


export const AnnotationQueueScoresScalarFieldEnum = {
  annotationQueueId: 'annotationQueueId',
  annotationScoreId: 'annotationScoreId'
} as const

export type AnnotationQueueScoresScalarFieldEnum = (typeof AnnotationQueueScoresScalarFieldEnum)[keyof typeof AnnotationQueueScoresScalarFieldEnum]


export const AnnotationQueueItemScalarFieldEnum = {
  id: 'id',
  annotationQueueId: 'annotationQueueId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdByUserId: 'createdByUserId',
  traceId: 'traceId',
  projectId: 'projectId',
  doneAt: 'doneAt',
  markedForDatasetAt: 'markedForDatasetAt'
} as const

export type AnnotationQueueItemScalarFieldEnum = (typeof AnnotationQueueItemScalarFieldEnum)[keyof typeof AnnotationQueueItemScalarFieldEnum]


export const ShareLinkScalarFieldEnum = {
  id: 'id',
  token: 'token',
  resourceType: 'resourceType',
  resourceId: 'resourceId',
  threadId: 'threadId',
  projectId: 'projectId',
  userId: 'userId',
  visibility: 'visibility',
  expiresAt: 'expiresAt',
  maxViews: 'maxViews',
  viewCount: 'viewCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ShareLinkScalarFieldEnum = (typeof ShareLinkScalarFieldEnum)[keyof typeof ShareLinkScalarFieldEnum]


export const PinnedTraceScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  traceId: 'traceId',
  userId: 'userId',
  source: 'source',
  reason: 'reason',
  createdAt: 'createdAt'
} as const

export type PinnedTraceScalarFieldEnum = (typeof PinnedTraceScalarFieldEnum)[keyof typeof PinnedTraceScalarFieldEnum]


export const TraceEditOverlayScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  traceId: 'traceId',
  patch: 'patch',
  createdById: 'createdById',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TraceEditOverlayScalarFieldEnum = (typeof TraceEditOverlayScalarFieldEnum)[keyof typeof TraceEditOverlayScalarFieldEnum]


export const RetentionPolicyScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  category: 'category',
  retentionDays: 'retentionDays',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RetentionPolicyScalarFieldEnum = (typeof RetentionPolicyScalarFieldEnum)[keyof typeof RetentionPolicyScalarFieldEnum]


export const DataPrivacyPolicyScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  personalOnly: 'personalOnly',
  config: 'config',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DataPrivacyPolicyScalarFieldEnum = (typeof DataPrivacyPolicyScalarFieldEnum)[keyof typeof DataPrivacyPolicyScalarFieldEnum]


export const CustomLLMModelCostScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  projectId: 'projectId',
  model: 'model',
  regex: 'regex',
  inputCostPerToken: 'inputCostPerToken',
  outputCostPerToken: 'outputCostPerToken',
  cacheReadCostPerToken: 'cacheReadCostPerToken',
  cacheCreationCostPerToken: 'cacheCreationCostPerToken',
  cacheCreation1hCostPerToken: 'cacheCreation1hCostPerToken',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CustomLLMModelCostScalarFieldEnum = (typeof CustomLLMModelCostScalarFieldEnum)[keyof typeof CustomLLMModelCostScalarFieldEnum]


export const WorkflowScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  icon: 'icon',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  latestVersionId: 'latestVersionId',
  currentVersionId: 'currentVersionId',
  publishedId: 'publishedId',
  publishedById: 'publishedById',
  archivedAt: 'archivedAt',
  isEvaluator: 'isEvaluator',
  isComponent: 'isComponent',
  copiedFromWorkflowId: 'copiedFromWorkflowId'
} as const

export type WorkflowScalarFieldEnum = (typeof WorkflowScalarFieldEnum)[keyof typeof WorkflowScalarFieldEnum]


export const WorkflowVersionScalarFieldEnum = {
  id: 'id',
  version: 'version',
  commitMessage: 'commitMessage',
  authorId: 'authorId',
  projectId: 'projectId',
  workflowId: 'workflowId',
  parentId: 'parentId',
  autoSaved: 'autoSaved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dsl: 'dsl'
} as const

export type WorkflowVersionScalarFieldEnum = (typeof WorkflowVersionScalarFieldEnum)[keyof typeof WorkflowVersionScalarFieldEnum]


export const AuditLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  projectId: 'projectId',
  organizationId: 'organizationId',
  action: 'action',
  args: 'args',
  error: 'error',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  metadata: 'metadata',
  actorUserId: 'actorUserId',
  targetKind: 'targetKind',
  targetId: 'targetId',
  before: 'before',
  after: 'after'
} as const

export type AuditLogScalarFieldEnum = (typeof AuditLogScalarFieldEnum)[keyof typeof AuditLogScalarFieldEnum]


export const LlmPromptConfigScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  projectId: 'projectId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  organizationId: 'organizationId',
  scope: 'scope',
  copiedFromPromptId: 'copiedFromPromptId'
} as const

export type LlmPromptConfigScalarFieldEnum = (typeof LlmPromptConfigScalarFieldEnum)[keyof typeof LlmPromptConfigScalarFieldEnum]


export const LlmPromptConfigVersionScalarFieldEnum = {
  id: 'id',
  version: 'version',
  commitMessage: 'commitMessage',
  authorId: 'authorId',
  configId: 'configId',
  configData: 'configData',
  schemaVersion: 'schemaVersion',
  runtimeParameters: 'runtimeParameters',
  createdAt: 'createdAt',
  projectId: 'projectId'
} as const

export type LlmPromptConfigVersionScalarFieldEnum = (typeof LlmPromptConfigVersionScalarFieldEnum)[keyof typeof LlmPromptConfigVersionScalarFieldEnum]


export const PromptTagAssignmentScalarFieldEnum = {
  id: 'id',
  configId: 'configId',
  versionId: 'versionId',
  tagId: 'tagId',
  projectId: 'projectId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type PromptTagAssignmentScalarFieldEnum = (typeof PromptTagAssignmentScalarFieldEnum)[keyof typeof PromptTagAssignmentScalarFieldEnum]


export const PromptTagScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type PromptTagScalarFieldEnum = (typeof PromptTagScalarFieldEnum)[keyof typeof PromptTagScalarFieldEnum]


export const AnalyticsScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  key: 'key',
  value: 'value',
  numericValue: 'numericValue',
  stringValue: 'stringValue',
  boolValue: 'boolValue',
  createdAt: 'createdAt'
} as const

export type AnalyticsScalarFieldEnum = (typeof AnalyticsScalarFieldEnum)[keyof typeof AnalyticsScalarFieldEnum]


export const CustomRoleScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  description: 'description',
  permissions: 'permissions',
  kind: 'kind',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CustomRoleScalarFieldEnum = (typeof CustomRoleScalarFieldEnum)[keyof typeof CustomRoleScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  projectId: 'projectId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sentAt: 'sentAt'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const AgentScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  type: 'type',
  config: 'config',
  workflowId: 'workflowId',
  copiedFromAgentId: 'copiedFromAgentId',
  environment: 'environment',
  ownerUserId: 'ownerUserId',
  hostLabel: 'hostLabel',
  identityKey: 'identityKey',
  lastSeenAt: 'lastSeenAt',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgentScalarFieldEnum = (typeof AgentScalarFieldEnum)[keyof typeof AgentScalarFieldEnum]


export const EvaluatorScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  slug: 'slug',
  type: 'type',
  config: 'config',
  workflowId: 'workflowId',
  copiedFromEvaluatorId: 'copiedFromEvaluatorId',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EvaluatorScalarFieldEnum = (typeof EvaluatorScalarFieldEnum)[keyof typeof EvaluatorScalarFieldEnum]


export const ScenarioScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  situation: 'situation',
  criteria: 'criteria',
  labels: 'labels',
  parameters: 'parameters',
  simulatorModel: 'simulatorModel',
  judgeModel: 'judgeModel',
  maxTurns: 'maxTurns',
  minTurns: 'minTurns',
  fields: 'fields',
  callerVoice: 'callerVoice',
  testSuiteId: 'testSuiteId',
  version: 'version',
  lastUpdatedById: 'lastUpdatedById',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScenarioScalarFieldEnum = (typeof ScenarioScalarFieldEnum)[keyof typeof ScenarioScalarFieldEnum]


export const ScenarioVersionScalarFieldEnum = {
  id: 'id',
  scenarioId: 'scenarioId',
  projectId: 'projectId',
  version: 'version',
  authorId: 'authorId',
  authorLabel: 'authorLabel',
  changeDescription: 'changeDescription',
  snapshot: 'snapshot',
  schemaVersion: 'schemaVersion',
  createdAt: 'createdAt'
} as const

export type ScenarioVersionScalarFieldEnum = (typeof ScenarioVersionScalarFieldEnum)[keyof typeof ScenarioVersionScalarFieldEnum]


export const SimulationSuiteScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  slug: 'slug',
  description: 'description',
  scenarioIds: 'scenarioIds',
  targets: 'targets',
  repeatCount: 'repeatCount',
  labels: 'labels',
  simulatorModel: 'simulatorModel',
  judgeModel: 'judgeModel',
  kind: 'kind',
  scope: 'scope',
  fields: 'fields',
  evaluators: 'evaluators',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SimulationSuiteScalarFieldEnum = (typeof SimulationSuiteScalarFieldEnum)[keyof typeof SimulationSuiteScalarFieldEnum]


export const SubscriptionScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  plan: 'plan',
  stripeSubscriptionId: 'stripeSubscriptionId',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  lastPaymentFailedDate: 'lastPaymentFailedDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  maxMembers: 'maxMembers',
  maxProjects: 'maxProjects',
  maxMessagesPerMonth: 'maxMessagesPerMonth',
  maxWorkflows: 'maxWorkflows',
  maxRetentionDays: 'maxRetentionDays',
  maxMembersLite: 'maxMembersLite',
  maxTeams: 'maxTeams',
  maxPrompts: 'maxPrompts',
  maxEvaluators: 'maxEvaluators',
  maxScenarios: 'maxScenarios',
  maxAgents: 'maxAgents',
  maxExperiments: 'maxExperiments',
  maxOnlineEvaluations: 'maxOnlineEvaluations',
  maxDatasets: 'maxDatasets',
  maxDashboards: 'maxDashboards',
  maxCustomGraphs: 'maxCustomGraphs',
  maxAutomations: 'maxAutomations'
} as const

export type SubscriptionScalarFieldEnum = (typeof SubscriptionScalarFieldEnum)[keyof typeof SubscriptionScalarFieldEnum]


export const InvoiceScalarFieldEnum = {
  id: 'id',
  subscriptionId: 'subscriptionId',
  totalAmount: 'totalAmount',
  currency: 'currency',
  dueDate: 'dueDate',
  paid: 'paid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InvoiceScalarFieldEnum = (typeof InvoiceScalarFieldEnum)[keyof typeof InvoiceScalarFieldEnum]


export const InvoiceItemScalarFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  description: 'description',
  amount: 'amount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InvoiceItemScalarFieldEnum = (typeof InvoiceItemScalarFieldEnum)[keyof typeof InvoiceItemScalarFieldEnum]


export const GroupScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  slug: 'slug',
  externalId: 'externalId',
  scimSource: 'scimSource',
  scimConnectionId: 'scimConnectionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GroupScalarFieldEnum = (typeof GroupScalarFieldEnum)[keyof typeof GroupScalarFieldEnum]


export const GroupMembershipScalarFieldEnum = {
  userId: 'userId',
  groupId: 'groupId',
  createdAt: 'createdAt'
} as const

export type GroupMembershipScalarFieldEnum = (typeof GroupMembershipScalarFieldEnum)[keyof typeof GroupMembershipScalarFieldEnum]


export const RoleBindingScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  userId: 'userId',
  groupId: 'groupId',
  apiKeyId: 'apiKeyId',
  role: 'role',
  customRoleId: 'customRoleId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RoleBindingScalarFieldEnum = (typeof RoleBindingScalarFieldEnum)[keyof typeof RoleBindingScalarFieldEnum]


export const GrantScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  principalType: 'principalType',
  principalId: 'principalId',
  roleKey: 'roleKey',
  legacyRole: 'legacyRole',
  source: 'source',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  token: 'token',
  permission: 'permission',
  resourceKind: 'resourceKind',
  projectId: 'projectId',
  createdByUserId: 'createdByUserId',
  expiresAt: 'expiresAt',
  maxViews: 'maxViews',
  occurredAt: 'occurredAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  revokedAt: 'revokedAt',
  revokedReason: 'revokedReason'
} as const

export type GrantScalarFieldEnum = (typeof GrantScalarFieldEnum)[keyof typeof GrantScalarFieldEnum]


export const GrantUsageScalarFieldEnum = {
  grantId: 'grantId',
  organizationId: 'organizationId',
  projectId: 'projectId',
  viewCount: 'viewCount',
  lastViewedAt: 'lastViewedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GrantUsageScalarFieldEnum = (typeof GrantUsageScalarFieldEnum)[keyof typeof GrantUsageScalarFieldEnum]


export const RoleScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  description: 'description',
  permissions: 'permissions',
  kind: 'kind',
  occurredAt: 'occurredAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type RoleScalarFieldEnum = (typeof RoleScalarFieldEnum)[keyof typeof RoleScalarFieldEnum]


export const ApiKeyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  lookupId: 'lookupId',
  hashedSecret: 'hashedSecret',
  permissionMode: 'permissionMode',
  userId: 'userId',
  createdByUserId: 'createdByUserId',
  organizationId: 'organizationId',
  expiresAt: 'expiresAt',
  lastUsedAt: 'lastUsedAt',
  revokedAt: 'revokedAt',
  revocationCause: 'revocationCause',
  parentApiKeyId: 'parentApiKeyId',
  ingestSourceType: 'ingestSourceType',
  ingestionTemplateId: 'ingestionTemplateId',
  createdByDeviceLabel: 'createdByDeviceLabel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ApiKeyScalarFieldEnum = (typeof ApiKeyScalarFieldEnum)[keyof typeof ApiKeyScalarFieldEnum]


export const BillingMeterCheckpointScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  billingMonth: 'billingMonth',
  meter: 'meter',
  lastReportedTotal: 'lastReportedTotal',
  pendingReportedTotal: 'pendingReportedTotal',
  consecutiveFailures: 'consecutiveFailures',
  updatedAt: 'updatedAt'
} as const

export type BillingMeterCheckpointScalarFieldEnum = (typeof BillingMeterCheckpointScalarFieldEnum)[keyof typeof BillingMeterCheckpointScalarFieldEnum]


export const VirtualKeyScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  description: 'description',
  status: 'status',
  purpose: 'purpose',
  externalId: 'externalId',
  metadata: 'metadata',
  disabledAt: 'disabledAt',
  disabledReason: 'disabledReason',
  expiresAt: 'expiresAt',
  hashedSecret: 'hashedSecret',
  displayPrefix: 'displayPrefix',
  principalUserId: 'principalUserId',
  traceProjectId: 'traceProjectId',
  config: 'config',
  revision: 'revision',
  previousHashedSecret: 'previousHashedSecret',
  previousSecretValidUntil: 'previousSecretValidUntil',
  revokedAt: 'revokedAt',
  revokedById: 'revokedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  lastUsedAt: 'lastUsedAt',
  routingPolicyId: 'routingPolicyId',
  routingMode: 'routingMode'
} as const

export type VirtualKeyScalarFieldEnum = (typeof VirtualKeyScalarFieldEnum)[keyof typeof VirtualKeyScalarFieldEnum]


export const VirtualKeyScopeScalarFieldEnum = {
  id: 'id',
  virtualKeyId: 'virtualKeyId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  createdAt: 'createdAt'
} as const

export type VirtualKeyScopeScalarFieldEnum = (typeof VirtualKeyScopeScalarFieldEnum)[keyof typeof VirtualKeyScopeScalarFieldEnum]


export const RoutingPolicyScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  description: 'description',
  modelProviderIds: 'modelProviderIds',
  modelAliases: 'modelAliases',
  defaultModel: 'defaultModel',
  policyRules: 'policyRules',
  isDefault: 'isDefault',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type RoutingPolicyScalarFieldEnum = (typeof RoutingPolicyScalarFieldEnum)[keyof typeof RoutingPolicyScalarFieldEnum]


export const RoutingPolicyScopeScalarFieldEnum = {
  id: 'id',
  routingPolicyId: 'routingPolicyId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  createdAt: 'createdAt'
} as const

export type RoutingPolicyScopeScalarFieldEnum = (typeof RoutingPolicyScopeScalarFieldEnum)[keyof typeof RoutingPolicyScopeScalarFieldEnum]


export const GatewayGuardrailScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  name: 'name',
  description: 'description',
  evaluatorId: 'evaluatorId',
  direction: 'direction',
  failureMode: 'failureMode',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type GatewayGuardrailScalarFieldEnum = (typeof GatewayGuardrailScalarFieldEnum)[keyof typeof GatewayGuardrailScalarFieldEnum]


export const IngestionSourceScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  teamId: 'teamId',
  sourceType: 'sourceType',
  name: 'name',
  description: 'description',
  ingestSecretHash: 'ingestSecretHash',
  parserConfig: 'parserConfig',
  pollerCursor: 'pollerCursor',
  errorCount: 'errorCount',
  pullSchedule: 'pullSchedule',
  status: 'status',
  traceProjectId: 'traceProjectId',
  providerAccountId: 'providerAccountId',
  lastEventAt: 'lastEventAt',
  lastSuccessAt: 'lastSuccessAt',
  lastReadThroughAt: 'lastReadThroughAt',
  lastRunCompleteness: 'lastRunCompleteness',
  unpricedUsageSince: 'unpricedUsageSince',
  unpricedUsageThrough: 'unpricedUsageThrough',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById'
} as const

export type IngestionSourceScalarFieldEnum = (typeof IngestionSourceScalarFieldEnum)[keyof typeof IngestionSourceScalarFieldEnum]


export const AnomalyRuleScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  scope: 'scope',
  scopeId: 'scopeId',
  name: 'name',
  description: 'description',
  severity: 'severity',
  ruleType: 'ruleType',
  thresholdConfig: 'thresholdConfig',
  destinationConfig: 'destinationConfig',
  status: 'status',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById'
} as const

export type AnomalyRuleScalarFieldEnum = (typeof AnomalyRuleScalarFieldEnum)[keyof typeof AnomalyRuleScalarFieldEnum]


export const AnomalyAlertScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  ruleId: 'ruleId',
  severity: 'severity',
  ruleName: 'ruleName',
  ruleType: 'ruleType',
  triggerWindowStart: 'triggerWindowStart',
  triggerWindowEnd: 'triggerWindowEnd',
  triggerSpendUsd: 'triggerSpendUsd',
  triggerEventCount: 'triggerEventCount',
  detail: 'detail',
  state: 'state',
  destinationStatus: 'destinationStatus',
  detectedAt: 'detectedAt',
  acknowledgedAt: 'acknowledgedAt',
  resolvedAt: 'resolvedAt'
} as const

export type AnomalyAlertScalarFieldEnum = (typeof AnomalyAlertScalarFieldEnum)[keyof typeof AnomalyAlertScalarFieldEnum]


export const AiToolEntryScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  scope: 'scope',
  scopeId: 'scopeId',
  type: 'type',
  displayName: 'displayName',
  slug: 'slug',
  iconKey: 'iconKey',
  iconAsset: 'iconAsset',
  order: 'order',
  enabled: 'enabled',
  config: 'config',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type AiToolEntryScalarFieldEnum = (typeof AiToolEntryScalarFieldEnum)[keyof typeof AiToolEntryScalarFieldEnum]


export const AiToolEntryTeamScalarFieldEnum = {
  id: 'id',
  entryId: 'entryId',
  teamId: 'teamId'
} as const

export type AiToolEntryTeamScalarFieldEnum = (typeof AiToolEntryTeamScalarFieldEnum)[keyof typeof AiToolEntryTeamScalarFieldEnum]


export const AiToolEntryDepartmentScalarFieldEnum = {
  id: 'id',
  entryId: 'entryId',
  departmentId: 'departmentId'
} as const

export type AiToolEntryDepartmentScalarFieldEnum = (typeof AiToolEntryDepartmentScalarFieldEnum)[keyof typeof AiToolEntryDepartmentScalarFieldEnum]


export const IngestionTemplateScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  slug: 'slug',
  sourceType: 'sourceType',
  displayName: 'displayName',
  description: 'description',
  iconAsset: 'iconAsset',
  credentialSchema: 'credentialSchema',
  ottlRules: 'ottlRules',
  platformPublished: 'platformPublished',
  enabled: 'enabled',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type IngestionTemplateScalarFieldEnum = (typeof IngestionTemplateScalarFieldEnum)[keyof typeof IngestionTemplateScalarFieldEnum]


export const GatewayBudgetScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  providerKey: 'providerKey',
  name: 'name',
  description: 'description',
  window: 'window',
  limitUsd: 'limitUsd',
  onBreach: 'onBreach',
  timezone: 'timezone',
  externalId: 'externalId',
  metadata: 'metadata',
  spentUsd: 'spentUsd',
  currentPeriodStartedAt: 'currentPeriodStartedAt',
  resetsAt: 'resetsAt',
  lastResetAt: 'lastResetAt',
  cycleAnchorAt: 'cycleAnchorAt',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  managedByVirtualKeyId: 'managedByVirtualKeyId'
} as const

export type GatewayBudgetScalarFieldEnum = (typeof GatewayBudgetScalarFieldEnum)[keyof typeof GatewayBudgetScalarFieldEnum]


export const GatewayBudgetBucketBoundaryScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  budgetId: 'budgetId',
  bucketScopeId: 'bucketScopeId',
  periodStartedAt: 'periodStartedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GatewayBudgetBucketBoundaryScalarFieldEnum = (typeof GatewayBudgetBucketBoundaryScalarFieldEnum)[keyof typeof GatewayBudgetBucketBoundaryScalarFieldEnum]


export const GatewayBudgetLedgerScalarFieldEnum = {
  id: 'id',
  budgetId: 'budgetId',
  virtualKeyId: 'virtualKeyId',
  modelProviderId: 'modelProviderId',
  providerKey: 'providerKey',
  gatewayRequestId: 'gatewayRequestId',
  amountUsd: 'amountUsd',
  tokensInput: 'tokensInput',
  tokensOutput: 'tokensOutput',
  tokensCacheRead: 'tokensCacheRead',
  tokensCacheWrite: 'tokensCacheWrite',
  model: 'model',
  durationMs: 'durationMs',
  status: 'status',
  occurredAt: 'occurredAt'
} as const

export type GatewayBudgetLedgerScalarFieldEnum = (typeof GatewayBudgetLedgerScalarFieldEnum)[keyof typeof GatewayBudgetLedgerScalarFieldEnum]


export const GatewayChangeEventScalarFieldEnum = {
  revision: 'revision',
  organizationId: 'organizationId',
  kind: 'kind',
  virtualKeyId: 'virtualKeyId',
  budgetId: 'budgetId',
  modelProviderId: 'modelProviderId',
  projectId: 'projectId',
  payload: 'payload',
  createdAt: 'createdAt'
} as const

export type GatewayChangeEventScalarFieldEnum = (typeof GatewayChangeEventScalarFieldEnum)[keyof typeof GatewayChangeEventScalarFieldEnum]


export const GatewayCacheRuleScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  description: 'description',
  priority: 'priority',
  enabled: 'enabled',
  matchers: 'matchers',
  action: 'action',
  modeEnum: 'modeEnum',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById'
} as const

export type GatewayCacheRuleScalarFieldEnum = (typeof GatewayCacheRuleScalarFieldEnum)[keyof typeof GatewayCacheRuleScalarFieldEnum]


export const FeatureFlagScalarFieldEnum = {
  key: 'key',
  enabled: 'enabled',
  rules: 'rules',
  lastEditedBy: 'lastEditedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureFlagScalarFieldEnum = (typeof FeatureFlagScalarFieldEnum)[keyof typeof FeatureFlagScalarFieldEnum]


export const ProcessManagerInstanceScalarFieldEnum = {
  id: 'id',
  processName: 'processName',
  projectId: 'projectId',
  processKey: 'processKey',
  tenantId: 'tenantId',
  userId: 'userId',
  state: 'state',
  revision: 'revision',
  nextWakeAt: 'nextWakeAt',
  updatedAt: 'updatedAt'
} as const

export type ProcessManagerInstanceScalarFieldEnum = (typeof ProcessManagerInstanceScalarFieldEnum)[keyof typeof ProcessManagerInstanceScalarFieldEnum]


export const ProcessManagerInboxScalarFieldEnum = {
  id: 'id',
  processName: 'processName',
  projectId: 'projectId',
  processKey: 'processKey',
  tenantId: 'tenantId',
  sourceEventId: 'sourceEventId',
  sourceEventKey: 'sourceEventKey',
  consumedAt: 'consumedAt'
} as const

export type ProcessManagerInboxScalarFieldEnum = (typeof ProcessManagerInboxScalarFieldEnum)[keyof typeof ProcessManagerInboxScalarFieldEnum]


export const ProcessManagerOutboxScalarFieldEnum = {
  id: 'id',
  processName: 'processName',
  projectId: 'projectId',
  processKey: 'processKey',
  tenantId: 'tenantId',
  userId: 'userId',
  messageKey: 'messageKey',
  intentType: 'intentType',
  payload: 'payload',
  traceCarrier: 'traceCarrier',
  sourceEventId: 'sourceEventId',
  status: 'status',
  attempts: 'attempts',
  nextAttemptAt: 'nextAttemptAt',
  leasedUntil: 'leasedUntil',
  leaseToken: 'leaseToken',
  dispatchedAt: 'dispatchedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ProcessManagerOutboxScalarFieldEnum = (typeof ProcessManagerOutboxScalarFieldEnum)[keyof typeof ProcessManagerOutboxScalarFieldEnum]


export const ProcessManagerOutboxAttemptScalarFieldEnum = {
  id: 'id',
  outboxId: 'outboxId',
  projectId: 'projectId',
  attempt: 'attempt',
  occurredAt: 'occurredAt',
  outcome: 'outcome',
  errorType: 'errorType',
  errorMessage: 'errorMessage',
  retryAfterMs: 'retryAfterMs'
} as const

export type ProcessManagerOutboxAttemptScalarFieldEnum = (typeof ProcessManagerOutboxAttemptScalarFieldEnum)[keyof typeof ProcessManagerOutboxAttemptScalarFieldEnum]


export const TopicClusteringRunProjectionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  LastRequestedAt: 'LastRequestedAt',
  LastRequestTrigger: 'LastRequestTrigger',
  LastRunAt: 'LastRunAt',
  LastRunOutcome: 'LastRunOutcome',
  LastRunMode: 'LastRunMode',
  LastRunSkippedReason: 'LastRunSkippedReason',
  LastRunError: 'LastRunError',
  LastRunErrorCode: 'LastRunErrorCode',
  LastRunErrorUserActionable: 'LastRunErrorUserActionable',
  LastRunTracesProcessed: 'LastRunTracesProcessed',
  LastRunTopicsCount: 'LastRunTopicsCount',
  LastRunSubtopicsCount: 'LastRunSubtopicsCount',
  LastRunPages: 'LastRunPages',
  InProgressRunId: 'InProgressRunId',
  InProgressTraces: 'InProgressTraces',
  InProgressPages: 'InProgressPages',
  InProgressStartedAt: 'InProgressStartedAt',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  LastEventId: 'LastEventId',
  ProjectionVersion: 'ProjectionVersion'
} as const

export type TopicClusteringRunProjectionScalarFieldEnum = (typeof TopicClusteringRunProjectionScalarFieldEnum)[keyof typeof TopicClusteringRunProjectionScalarFieldEnum]


export const TopicModelProjectionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  LastEventId: 'LastEventId',
  ProjectionVersion: 'ProjectionVersion'
} as const

export type TopicModelProjectionScalarFieldEnum = (typeof TopicModelProjectionScalarFieldEnum)[keyof typeof TopicModelProjectionScalarFieldEnum]


export const TopicClusteringRunHistoryProjectionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  Runs: 'Runs',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  LastEventId: 'LastEventId',
  ProjectionVersion: 'ProjectionVersion'
} as const

export type TopicClusteringRunHistoryProjectionScalarFieldEnum = (typeof TopicClusteringRunHistoryProjectionScalarFieldEnum)[keyof typeof TopicClusteringRunHistoryProjectionScalarFieldEnum]


export const IngestionPullRunProjectionScalarFieldEnum = {
  id: 'id',
  sourceId: 'sourceId',
  projectId: 'projectId',
  Enabled: 'Enabled',
  Cron: 'Cron',
  Cursor: 'Cursor',
  LastRunAt: 'LastRunAt',
  LastRunOutcome: 'LastRunOutcome',
  LastRunEventCount: 'LastRunEventCount',
  LastRunError: 'LastRunError',
  LastRunErrorCode: 'LastRunErrorCode',
  ConsecutiveErrors: 'ConsecutiveErrors',
  LastSuccessAt: 'LastSuccessAt',
  LastRunScheduledFor: 'LastRunScheduledFor',
  LastReadThroughAt: 'LastReadThroughAt',
  LastRunCompleteness: 'LastRunCompleteness',
  LastAgentsListingAt: 'LastAgentsListingAt',
  LastAgentsListingOutcome: 'LastAgentsListingOutcome',
  LastAgentsListingCount: 'LastAgentsListingCount',
  LastAgentsListingReason: 'LastAgentsListingReason',
  LastAgentsListingStatus: 'LastAgentsListingStatus',
  LastPeopleListingAt: 'LastPeopleListingAt',
  LastPeopleListingOutcome: 'LastPeopleListingOutcome',
  LastPeopleDirectoryCount: 'LastPeopleDirectoryCount',
  LastPeopleWithheldCount: 'LastPeopleWithheldCount',
  LastPeopleListingReason: 'LastPeopleListingReason',
  LastPeopleListingStatus: 'LastPeopleListingStatus',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  OccurredAt: 'OccurredAt',
  AcceptedAt: 'AcceptedAt',
  LastEventId: 'LastEventId',
  ProjectionVersion: 'ProjectionVersion'
} as const

export type IngestionPullRunProjectionScalarFieldEnum = (typeof IngestionPullRunProjectionScalarFieldEnum)[keyof typeof IngestionPullRunProjectionScalarFieldEnum]


export const ScheduledJobScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  targetType: 'targetType',
  targetId: 'targetId',
  cron: 'cron',
  timezone: 'timezone',
  nextRunAt: 'nextRunAt',
  lastSlot: 'lastSlot',
  currentSlot: 'currentSlot',
  attempts: 'attempts',
  lastError: 'lastError',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduledJobScalarFieldEnum = (typeof ScheduledJobScalarFieldEnum)[keyof typeof ScheduledJobScalarFieldEnum]


export const BugReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  source: 'source',
  kind: 'kind',
  title: 'title',
  summary: 'summary',
  sessionData: 'sessionData',
  sessionTruncated: 'sessionTruncated',
  agent: 'agent',
  contactEmail: 'contactEmail',
  cliVersion: 'cliVersion',
  linkedProjectId: 'linkedProjectId',
  metadata: 'metadata'
} as const

export type BugReportScalarFieldEnum = (typeof BugReportScalarFieldEnum)[keyof typeof BugReportScalarFieldEnum]


export const IdempotencyReceiptScalarFieldEnum = {
  id: 'id',
  scopeId: 'scopeId',
  key: 'key',
  claimId: 'claimId',
  requestFingerprint: 'requestFingerprint',
  responseStatus: 'responseStatus',
  responseBody: 'responseBody',
  createdAt: 'createdAt',
  heartbeatAt: 'heartbeatAt',
  expiresAt: 'expiresAt'
} as const

export type IdempotencyReceiptScalarFieldEnum = (typeof IdempotencyReceiptScalarFieldEnum)[keyof typeof IdempotencyReceiptScalarFieldEnum]


export const GatewayRealtimeSessionScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  organizationId: 'organizationId',
  virtualKeyId: 'virtualKeyId',
  modelProviderId: 'modelProviderId',
  vendor: 'vendor',
  agentId: 'agentId',
  model: 'model',
  requestedModel: 'requestedModel',
  vendorConversationId: 'vendorConversationId',
  status: 'status',
  mintedAt: 'mintedAt',
  closedAt: 'closedAt',
  closeReason: 'closeReason',
  traceId: 'traceId',
  vendorCostRaw: 'vendorCostRaw',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GatewayRealtimeSessionScalarFieldEnum = (typeof GatewayRealtimeSessionScalarFieldEnum)[keyof typeof GatewayRealtimeSessionScalarFieldEnum]


export const SystemMigrationTenantStateScalarFieldEnum = {
  migrationName: 'migrationName',
  tenantId: 'tenantId',
  status: 'status',
  report: 'report',
  occurredAt: 'occurredAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SystemMigrationTenantStateScalarFieldEnum = (typeof SystemMigrationTenantStateScalarFieldEnum)[keyof typeof SystemMigrationTenantStateScalarFieldEnum]


export const SystemMigrationEnrollmentScalarFieldEnum = {
  organizationId: 'organizationId',
  migrationName: 'migrationName',
  enrolledByUserId: 'enrolledByUserId',
  createdAt: 'createdAt'
} as const

export type SystemMigrationEnrollmentScalarFieldEnum = (typeof SystemMigrationEnrollmentScalarFieldEnum)[keyof typeof SystemMigrationEnrollmentScalarFieldEnum]


export const DiscoveredPersonScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  provider: 'provider',
  rawActorId: 'rawActorId',
  displayText: 'displayText',
  kind: 'kind',
  department: 'department',
  firstSeenAt: 'firstSeenAt',
  lastSeenAt: 'lastSeenAt',
  erasedAt: 'erasedAt',
  moneyRowsPendingAt: 'moneyRowsPendingAt',
  moneyRebuildSince: 'moneyRebuildSince',
  suspendedAt: 'suspendedAt',
  suspendedReason: 'suspendedReason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DiscoveredPersonScalarFieldEnum = (typeof DiscoveredPersonScalarFieldEnum)[keyof typeof DiscoveredPersonScalarFieldEnum]


export const DiscoveredAgentScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  provider: 'provider',
  rawAgentId: 'rawAgentId',
  displayText: 'displayText',
  metadata: 'metadata',
  firstSeenAt: 'firstSeenAt',
  lastSeenAt: 'lastSeenAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DiscoveredAgentScalarFieldEnum = (typeof DiscoveredAgentScalarFieldEnum)[keyof typeof DiscoveredAgentScalarFieldEnum]


export const IdentityMatchScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  discoveredPersonId: 'discoveredPersonId',
  userId: 'userId',
  evidenceKind: 'evidenceKind',
  validFrom: 'validFrom',
  validTo: 'validTo',
  createdAt: 'createdAt'
} as const

export type IdentityMatchScalarFieldEnum = (typeof IdentityMatchScalarFieldEnum)[keyof typeof IdentityMatchScalarFieldEnum]


export const GovernanceTenantHistoryScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  tenantId: 'tenantId',
  firstUsedAt: 'firstUsedAt',
  lastUsedAt: 'lastUsedAt'
} as const

export type GovernanceTenantHistoryScalarFieldEnum = (typeof GovernanceTenantHistoryScalarFieldEnum)[keyof typeof GovernanceTenantHistoryScalarFieldEnum]


export const ErasedIdentifierSuppressionScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  provider: 'provider',
  identifierHash: 'identifierHash',
  erasedAt: 'erasedAt'
} as const

export type ErasedIdentifierSuppressionScalarFieldEnum = (typeof ErasedIdentifierSuppressionScalarFieldEnum)[keyof typeof ErasedIdentifierSuppressionScalarFieldEnum]


export const IdentityMatchSuggestionScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  discoveredPersonId: 'discoveredPersonId',
  userId: 'userId',
  score: 'score',
  computedAt: 'computedAt'
} as const

export type IdentityMatchSuggestionScalarFieldEnum = (typeof IdentityMatchSuggestionScalarFieldEnum)[keyof typeof IdentityMatchSuggestionScalarFieldEnum]


export const ConnectedSeatChangeScalarFieldEnum = {
  id: 'id',
  licenseId: 'licenseId',
  accountId: 'accountId',
  changedAt: 'changedAt',
  addedSeats: 'addedSeats',
  unitAmountCents: 'unitAmountCents',
  amountCents: 'amountCents',
  currency: 'currency',
  stripeInvoiceId: 'stripeInvoiceId',
  state: 'state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ConnectedSeatChangeScalarFieldEnum = (typeof ConnectedSeatChangeScalarFieldEnum)[keyof typeof ConnectedSeatChangeScalarFieldEnum]


export const ConnectedStatementScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  month: 'month',
  sentAt: 'sentAt'
} as const

export type ConnectedStatementScalarFieldEnum = (typeof ConnectedStatementScalarFieldEnum)[keyof typeof ConnectedStatementScalarFieldEnum]


export const InstanceIdentityScalarFieldEnum = {
  id: 'id',
  instanceId: 'instanceId',
  createdAt: 'createdAt',
  lastReportAt: 'lastReportAt',
  lastReportError: 'lastReportError',
  optionalMetricsOptOut: 'optionalMetricsOptOut',
  hostnameOptOut: 'hostnameOptOut'
} as const

export type InstanceIdentityScalarFieldEnum = (typeof InstanceIdentityScalarFieldEnum)[keyof typeof InstanceIdentityScalarFieldEnum]


export const SelfHostedInstanceScalarFieldEnum = {
  id: 'id',
  instanceId: 'instanceId',
  firstSeenAt: 'firstSeenAt',
  lastSeenAt: 'lastSeenAt',
  version: 'version',
  installMethod: 'installMethod',
  chartVersion: 'chartVersion',
  hostname: 'hostname',
  environment: 'environment',
  installedAt: 'installedAt',
  reportSchemaVersion: 'reportSchemaVersion',
  organizationId: 'organizationId',
  issuedLicenseId: 'issuedLicenseId',
  userEmailDomains: 'userEmailDomains',
  userDomains: 'userDomains',
  latestReport: 'latestReport',
  optionalMetricsReported: 'optionalMetricsReported',
  hostnameReported: 'hostnameReported',
  reportCount: 'reportCount',
  lastUnknownFields: 'lastUnknownFields',
  raisedSignals: 'raisedSignals',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SelfHostedInstanceScalarFieldEnum = (typeof SelfHostedInstanceScalarFieldEnum)[keyof typeof SelfHostedInstanceScalarFieldEnum]


export const SelfHostedInstanceReportScalarFieldEnum = {
  id: 'id',
  instanceId: 'instanceId',
  receivedAt: 'receivedAt',
  version: 'version',
  reportSchemaVersion: 'reportSchemaVersion',
  unknownFields: 'unknownFields',
  payload: 'payload'
} as const

export type SelfHostedInstanceReportScalarFieldEnum = (typeof SelfHostedInstanceReportScalarFieldEnum)[keyof typeof SelfHostedInstanceReportScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

